import { render, staticRenderFns } from "./IntroxlReapply.vue?vue&type=template&id=674df5b7"
import script from "./IntroxlReapply.vue?vue&type=script&lang=js"
export * from "./IntroxlReapply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports